export const environment = {
  production: false,
  apiUrl: 'https://bidvest-staging-api.skywalkinnovations.co.za/api'
};
